import PermissionEditForm from "./permission-edit-form/permission-edit-form";

const PermissionForms = {
    Edit: PermissionEditForm,
};

export default PermissionForms;